import {
  LayoutDashboard,
  Component,
  Settings,
  Users,
  Building2,
  ShieldCheck,
  Network,
  Sparkles,
  ClipboardList,
  FileStack,
  ClipboardSignature,
  Target,
  Leaf,
  BarChart2,
  FileText,
  ClipboardCheck,
  Globe,
  SlidersHorizontal,
  Receipt,
  Layers,
  FileCheck,
  BookOpen,
} from "lucide-react";
import { PATHS } from "@/lib/router";
import { TableProperties } from "lucide-react";
import config from "./config";
import { ListChecks } from "lucide-react";

export const NAVIGATION_SECTIONS = {
  OVERVIEW: "navigation.overview",
  DATA: "navigation.data",
  MANAGEMENT: "navigation.management",
};

const isLocalhost =
  typeof window !== "undefined" && window.location.hostname === "localhost";

export const navigationItems = [
  {
    label: "navigation.dashboard",
    icon: LayoutDashboard,
    link: PATHS.DASHBOARD,
    section: NAVIGATION_SECTIONS.OVERVIEW,
    permissionKey: "company_information",
  },
  {
    label: "Companies",
    icon: Building2,
    link: PATHS.COMPANY_LIST,
    section: NAVIGATION_SECTIONS.OVERVIEW,
    allowedRoles: ["system_admin"],
  },
  {
    label: "navigation.organization",
    icon: Network,
    link: PATHS.ORGANIZATION,
    section: NAVIGATION_SECTIONS.OVERVIEW,
    permissionKey: "organization",
  },
  ...(isLocalhost
    ? [
        {
          label: "Components",
          icon: Component,
          link: PATHS.COMPONENTS,
          section: NAVIGATION_SECTIONS.OVERVIEW,
        },
      ]
    : []),
  {
    label: "navigation.carbonInventory",
    icon: Leaf,
    section: NAVIGATION_SECTIONS.DATA,
    permissionKey: "carbon_inventory",
    subItems: [
      {
        label: "navigation.carbonInventoryDashboard",
        icon: BarChart2,
        link: PATHS.CARBON_DASHBOARD,
        permissionKey: "carbon_dashboard",
      },
      {
        label: "navigation.carbonInventoryTargetSettings",
        icon: Target,
        link: PATHS.CARBON_TARGETS,
        permissionKey: "carbon_target_setting",
      },
      {
        label: "navigation.carbonInventorySubmissions",
        icon: FileText,
        link: PATHS.CARBON_SUBMISSIONS,
        permissionKey: "carbon_submissions",
      },
      {
        label: "navigation.carbonSurveys",
        icon: ClipboardCheck,
        link: PATHS.CARBON_SURVEYS,
        permissionKey: "carbon_surveys",
      },
    ],
  },
  {
    label: "ESG Dashboard",
    icon: BarChart2,
    link: PATHS.ANALYTICS_DASHBOARD,
    benchmarkLink: PATHS.BENCHMARK_DASHBOARD,
    benchmarkLabel: "Benchmark Dashboard",
    section: NAVIGATION_SECTIONS.DATA,
    permissionKey: "esg_dashboard",
  },
  {
    label: "navigation.kpiTargetSettings",
    icon: Target,
    section: NAVIGATION_SECTIONS.DATA,
    permissionKey: "kpi_configuration",
    // hide: config.isStaging,
    subItems: [
      {
        label: "navigation.reportingBoundary",
        icon: Globe,
        link: PATHS.ESG_REPORTING_BOUNDARY,
        permissionKey: "reporting_boundary",
        // hide: config.isStaging,
      },
      {
        label: "Metric Assignment",
        icon: ListChecks,
        link: PATHS.ESG_MASTER_DATA,
        permissionKey: "master_data",
        // hide: config.isStaging,
      },
      {
        label: "navigation.targetSetup",
        icon: SlidersHorizontal,
        link: PATHS.TARGET_SETUP,
        permissionKey: "target_setting",
        // hide: config.isStaging,
      },
      {
        label: "Custom Frameworks",
        icon: Layers,
        link: PATHS.CUSTOM_FRAMEWORK_LIST,
        permissionKey: "custom_framework",
        companyFeatureFlag: "customFrameworkEnabled",
      },
    ],
  },
  {
    label: "ESG Data Entry",
    icon: TableProperties,
    link: PATHS.DATA_ENTRY,
    section: NAVIGATION_SECTIONS.DATA,
    permissionKey: "esg_data_entry",
    // hide: config.isStaging,
  },
  {
    label: "navigation.esgReporting",
    icon: FileText,
    link: PATHS.ESG_REPORT_PREVIEW_LIST,
    activeMatch: [PATHS.ESG_REPORT_PREVIEW, PATHS.ESG_REPORT_PREVIEW_LIST],
    section: NAVIGATION_SECTIONS.DATA,
    permissionKey: "esg_reporting",
    // hide: config.isStaging,
  },
  {
    label: "Bill Import (OCR)",
    icon: Receipt,
    link: PATHS.BILL_OCR,
    section: NAVIGATION_SECTIONS.DATA,
    permissionKey: "esg_data_entry",
    hide: !["dev.nxstart.evercomm.io", "localhost"].includes(
      window.location.hostname,
    ),
  },
  {
    label: "navigation.moreSolutions",
    icon: Sparkles,
    link: PATHS.MORE_SOLUTIONS,
    section: NAVIGATION_SECTIONS.DATA,
    permissionKey: "onboard_setup",
    // hide: config.isStaging,
  },
  {
    label: "navigation.surveys",
    icon: ClipboardSignature,
    link: PATHS.SURVEYS,
    section: NAVIGATION_SECTIONS.DATA,
    permissionKey: "surveys",
    hide: config.isStaging,
  },
  {
    label: "navigation.settings",
    icon: Settings,
    link: PATHS.SETTINGS,
    section: NAVIGATION_SECTIONS.MANAGEMENT,
    permissionKey: "user_profile",
    defaultView: true,
  },
  {
    label: "navigation.userManagementSection",
    icon: Users,
    section: NAVIGATION_SECTIONS.MANAGEMENT,
    permissionKey: "user_management",
    subItems: [
      {
        label: "navigation.rolesAndPermissions",
        icon: ShieldCheck,
        link: PATHS.ROLES_PERMISSIONS,
        permissionKey: "roles_permissions",
      },
      {
        label: "navigation.users",
        icon: Users,
        link: PATHS.USER_LIST,
        permissionKey: "user_list",
      },
    ],
  },
  {
    label: "navigation.surveyManagementSection",
    icon: FileStack,
    section: NAVIGATION_SECTIONS.MANAGEMENT,
    permissionKey: "survey_management",
    subItems: [
      {
        label: "navigation.surveryLibrary",
        icon: ClipboardSignature,
        link: PATHS.SURVEY_LIBRARY,
        permissionKey: "survey_library",
      },
      {
        label: "navigation.questionLibrary",
        icon: BookOpen,
        link: PATHS.QUESTION_LIBRARY,
        permissionKey: "question_library",
      },
      {
        label: "navigation.surveyResponses",
        icon: FileCheck,
        link: PATHS.SURVEY_RESPONSES,
        permissionKey: "survey_responses",
      },
    ],
  },
  {
    label: "navigation.activityLog",
    icon: ClipboardList,
    link: PATHS.ACTIVITY_LOG,
    section: NAVIGATION_SECTIONS.MANAGEMENT,
    permissionKey: "activity_log",
    defaultView: true,
  },
];
